import { render, staticRenderFns } from "./digital-donation-receipt.vue?vue&type=template&id=1b86b466"
import script from "./digital-donation-receipt.vue?vue&type=script&lang=ts"
export * from "./digital-donation-receipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports